import { useEffect } from 'react';
import { CreateSpreadsheetPanel } from '../../../dialogs/CreateSpreadsheetPanel';
import { useCreateSpreadsheet } from '../../../../hooks/entity/useCreateSpreadsheet';
import type { CreateBodyProps } from './createBodyProps';
import { destinationProjectId } from '../destination/createDestination';

/** New spreadsheet, in the chosen collection or at the workspace root. */
export function SpreadsheetBody({
  destination,
  onDone,
  onDestinationProblem,
  onBusyChange,
}: CreateBodyProps) {
  const spreadsheet = useCreateSpreadsheet({ onDestinationProblem });
  useEffect(() => onBusyChange(spreadsheet.isBusy), [spreadsheet.isBusy, onBusyChange]);
  return (
    <CreateSpreadsheetPanel
      projectId={destinationProjectId(destination)}
      onDone={onDone}
      spreadsheet={spreadsheet}
    />
  );
}
